export const BLUR_PHONE_NUMBER_ACTION = "username-recovery/BLUR_PHONE_NUMBER_ACTION";

export default function blurPhoneNumberAction() {
  return {
    "payload": {},
    "type": BLUR_PHONE_NUMBER_ACTION
  };
}
